import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';
import { IClosePaymentRunResponse } from '../models/close-payment-run-response.model';

export const closePaymentRunFeatureKey = 'closePaymentRun';

export interface ClosePaymentRunState {
  success: IClosePaymentRunResponse | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: ClosePaymentRunState = {
  success: null,
  failure: null,
  loading: false
};

export const closePaymentRunReducer = createReducer(
  initialState,
  on(fromPaymentsActions.closePaymentRun, (state) => ({
    ...state,
    success: null,
    failure: null,
    loading: true
  })),
  on(fromPaymentsActions.closePaymentRunSuccess, (state, { response }) => ({
    ...state,
    success: response,
    failure: null,
    loading: false
  })),
  on(fromPaymentsActions.closePaymentRunFailure, (state, { error }) => ({
    ...state,
    success: null,
    failure: error,
    loading: false
  }))
);
